// Components==============
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import React, { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { sortOnName } from 'utilities/sortOnName';
import Explorer from './components/Explorer/Explorer';
import Route from './components/Route';
import Top from './components/Top';
import './index.module.scss';
// =========================

export const GroupContext = createContext(null);

export default function Group() {
    const [files, setFiles] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [orderOn, setOrderOn] = useState({ key: 'name', asc: true });

    const { id } = useParams();

    const group = useSelector((state) => state.group.entities.byId[id]);
    const groupEntities = useSelector((state) =>
        state.group.entities.allIds.map((i) => state.group.entities.byId[i])
    );

    const [members, setMembers] = useState([]);

    useEffect(() => {
        const getMembersCount = (folder) => {
            if (!folder) return;
            if (folder?.users?.length) return setMembers(folder?.users);

            getMembersCount(
                groupEntities.find((f) => f.id === folder.parent_id)
            );
        };

        getMembersCount(group);
    }, []);

    const folders = useSelector((state) =>
        state.group.entities.allIds.map((i) => state.group.entities.byId[i])
    ).filter((folder) => folder?.parent_id === group.id);

    const documents = [...folders, ...group?.files]
        ?.filter((doc) =>
            searchValue.length
                ? doc?.name?.toLowerCase().includes(searchValue.toLowerCase())
                : true
        )
        ?.sort((a, b) => {
            if (orderOn.key === 'name' && orderOn.asc) return sortOnName(a, b);
            if (orderOn.key === 'name' && !orderOn.asc) return sortOnName(b, a);
            if (orderOn.key === 'date' && orderOn.asc)
                return (
                    new Date(a.updated_at).getTime() >
                    new Date(b.updated_at).getTime()
                );
            if (orderOn.key === 'date' && !orderOn.asc)
                return (
                    new Date(a.updated_at).getTime() <
                    new Date(b.updated_at).getTime()
                );

            if (orderOn.key === 'owner' && orderOn.asc)
                return sortOnName(a, b, 'updated_at');
            if (orderOn.key === 'owner' && !orderOn.asc)
                return sortOnName(b, a, 'updated_at');

            return 0;
        });

    return (
        <GroupContext.Provider
            value={{
                files,
                setFiles,
                searchValue,
                setSearchValue,
                orderOn,
                setOrderOn,
                group,
                documents,
                members,
            }}
        >
            <Layout dashboard>
                <Container>
                    <div styleName="content">
                        <Top />
                        <Route />
                        <Explorer />
                    </div>
                </Container>
            </Layout>
        </GroupContext.Provider>
    );
}
